import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subscription } from 'rxjs';
import {
    TxUpdateWorkflowRequest,
    TxWfCalendar,
    TxWorkflow,
    TxWorkflowCalendarProtokoll,
    TxWorkflowCalendarRequest,
    TxWorkflowRequest,
    TxWorkflows,
} from '../../shared/interfaces/workflow';
import { TxApiService } from '../../shared/services/txapi.service';
import { TabStates, TabStateService } from '../../shared/services/tabstate.service';
import { NavigationEnd, Router } from '@angular/router';
import { HeartbeatService } from '../../shared/services/heartbeat.service';
import { CalendarService } from '../../shared/services/calendar.service';
import { filter } from 'rxjs/operators';
import moment from 'moment';

declare let Messenger: any;
declare let jQuery: any;

@Component({
    selector: 'tx-txworkflow',
    templateUrl: './txworkflow.component.html',
    styleUrls: ['./txworkflow.component.scss'],
    providers: [TabStateService],
})
export class TxWorkflowComponent implements OnInit, OnDestroy {

    @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
        if (mp) this.dataSource.paginator = mp;
    }

    constructor(
        private myTxApiservice: TxApiService,
        public myTabStateService: TabStateService,
        private router: Router,
        private hearbeatService: HeartbeatService,
        private calendarService: CalendarService,
    ) {}
    tabState: TabStates;

    buchungForm = 'Buchung';
    antragForm = 'Antrag';

    Workflow;
    myWorkflowCalendar: Array<TxWfCalendar>;

    myWorkflowHasData = false;

    displayedColumns = ['datum', 'typ', 'name', 'bearbeiter', 'notiz', 'antwort', 'status', 'actions'];
    expandedColumns = ['expandedInfo'];
    dataSource = new MatTableDataSource<TxWorkflows>([]);

    // Track router subscription for proper cleanup
    private routerSubscription: Subscription;

    // Flag to track if initial data load has happened
    private initialDataLoaded = false;
    hasInfo = (_: number, row: TxWorkflows) => !!(row as any).info;

    getWorkflow() {
        let myWorkflowData: Observable<TxWorkflow>;
        const myWorkflowRequestData = new TxWorkflowRequest();
        myWorkflowRequestData.from = '2010-02-01T04:58:21';
        myWorkflowRequestData.to = '2026-12-08T04:58:21';

        myWorkflowData = this.myTxApiservice.callAPI('getWorkflow', myWorkflowRequestData);
        myWorkflowData.subscribe(
            (response) => {
                this.Workflow = response.Workflows;
                if (this.Workflow.length > 0) {
                    this.myWorkflowHasData = true;
                }
                this.refreshDataSource();
            },
            (error) => {
                console.log('ERROR' + error);
            }
        );
    }

    private refreshDataSource() {
        this.dataSource.data = [...(this.Workflow || [])];
    }

    getWorkflowCalendar(clear=true) {
        // Prevent unnecessary API calls if data is already loaded and clear=false
        if (!clear && this.myWorkflowCalendar) {
            return;
        }

        let myWorkflowCalendarData: Observable<TxWorkflowCalendarProtokoll>;
        const myWorkflowCalendarRequestData = new TxWorkflowCalendarRequest();
        myWorkflowCalendarRequestData.full_year = 0;

        if(clear){
            this.myWorkflowCalendar = null;
        }
        myWorkflowCalendarData = this.myTxApiservice.callAPI('getWfCalendar', myWorkflowCalendarRequestData);
        myWorkflowCalendarData.subscribe(
            (responseData) => {
                this.myWorkflowCalendar = responseData.WfCalendar;
            },
            (error) => {
                console.log('ERROR' + error);
            }
        );
    }

    onDeleteClick(aWfRow: any) {
        this.updateWorkflow(aWfRow, 100); // 100=löschen
        this.Workflow = this.Workflow.filter((elem) => elem !== aWfRow);
        this.refreshDataSource();
    }

    updateFromComponent() {
        setTimeout(() => {
            this.getWorkflow();
            // Trigger calendar update for current user
            this.triggerCalendarUpdateForCurrentUser();
        }, 50);
    }

    private triggerCalendarUpdateForCurrentUser() {
        // Get current user info
        const currentUser = JSON.parse(localStorage.getItem('currentSession'));
        if (!currentUser) return;

        // Use a broader date range to catch all possible new entries
        // Cover past month to next month to be sure we catch everything
        const startDate = moment().subtract(1, 'month').format('YYYY-MM-DD');
        const endDate = moment().add(1, 'month').format('YYYY-MM-DD');

        setTimeout(() => {
            this.calendarService.triggerWorkflowCalendarUpdate(startDate, endDate, 0);
        }, 1000);
    }

    onTabOpen(name) {
        this.myTabStateService.onTabOpen(name);
        switch (name) {
            case 'w1':
                this.watchWorkflowCalendar();
                break;
            case 'w4':
                this.watchWorkflow();
                break;
        }
    }

    onTabClose(name) {
        this.myTabStateService.onTabClose(name);
        switch (name) {
            case 'w1':
                this.unwatchWorkflowCalendar();
                break;
            case 'w4':
                this.unwatchWorkflow();
                break;
        }
    }

    hoverBoth($event: MouseEvent) {
        if ($event.type === 'mouseenter') {
            const prev = $event.target as Element;
            prev.previousElementSibling.classList.add('hover');
        } else {
            document.querySelectorAll('.bb-0').forEach((el) => el.classList.remove('hover'));
        }
    }

    updateWorkflow(aWfRow, status) {
        const aWfRequest: TxUpdateWorkflowRequest = new TxUpdateWorkflowRequest(aWfRow.id, status, null); // 100=löschen

        let apiAnfrage: Observable<TxUpdateWorkflowRequest>;
        let myResponse: any;

        apiAnfrage = this.myTxApiservice.callAPI('updateWorkflow', aWfRequest);

        apiAnfrage.subscribe(
            (mySessionData) => {
                myResponse = mySessionData;
                let responseStatus: string;
                if (myResponse.statuscode === 0) {
                    responseStatus = 'success';
                    this.triggerCalendarUpdate(aWfRow);
                } else {
                    responseStatus = 'error';
                }
                Messenger().post({
                    message: myResponse.statustext,
                    type: responseStatus,
                    showCloseButton: true,
                    hideAfter: 5,
                });
            },
            (error) => {
                console.log('ERROR' + error);
                Messenger().post({
                    message: 'ERROR' + error,
                    type: 'error',
                    showCloseButton: true,
                });
            }
        );
    }

    private triggerCalendarUpdate(aWfRow: any) {
        const startDate = moment(aWfRow.von).format('YYYY-MM-DD');
        const endDate = moment(aWfRow.bis || aWfRow.von).format('YYYY-MM-DD');
        
        setTimeout(() => {
            this.calendarService.triggerWorkflowCalendarUpdate(startDate, endDate, 0);
        }, 1000);
    }

    onConfirmClick(aWfRow: any) {
        this.Workflow = this.Workflow.filter((elem) => elem !== aWfRow);
        this.updateWorkflow(aWfRow, 101); // 101=confirm
        this.refreshDataSource();
    }

    onApproveClick(aWfRow: any) {
        this.Workflow = this.Workflow.filter((elem) => elem !== aWfRow);
        this.updateWorkflow(aWfRow, 200); // 101=confirm
        this.refreshDataSource();
    }

    onDeclineClick(aWfRow: any) {
        this.Workflow = this.Workflow.filter((elem) => elem !== aWfRow);
        this.updateWorkflow(aWfRow, 201); // 101=confirm
        this.refreshDataSource();
    }

    checkBisData(bisData: any) {
        return bisData !== '';
    }

    refresh() {
        // Only refresh if not initial data load
        if (this.initialDataLoaded) {
            this.getWorkflowCalendar();
            this.getWorkflow();
        }
    }

    ngOnInit(): void {
        this.tabState = this.myTabStateService.getTabState();

        // Load data only once at initialization
        this.initialLoad();

        // Subscribe to router events but avoid duplicate calls
        this.routerSubscription = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd &&
                event.url.indexOf('workflow') > -1)
        ).subscribe(() => {
            // Only refresh if coming from a different route
            console.log('Router navigation to workflow route');
            this.refresh();
        });

        this.watchWorkflow();
    }

    // New method to handle initial data loading
    private initialLoad() {
        this.getWorkflow();
        this.getWorkflowCalendar();
        this.initialDataLoaded = true;
    }

    public watchWorkflow() {
        if (this.myTabStateService.getTabState('w4')) {
            this.hearbeatService.addToHeartbeat('workflow', () => {
                this.getWorkflow();
            }, 60)
        }
    }

    public unwatchWorkflow() {
        this.hearbeatService.removeFromHeartbeat('workflow');
    }

    public watchWorkflowCalendar() {
        /* TODO: finish workflow calendar update in next version
        if (this.myTabStateService.getTabState('w1')) {
            this.hearbeatService.addToHeartbeat('workflowCalendar', () => {
                // Pass false to avoid clearing existing data if already loaded
                this.getWorkflowCalendar(false);
            }, 120)
        }
        */
    }

    public unwatchWorkflowCalendar() {
        /* TODO: finish workflow calendar update in next version
        this.hearbeatService.removeFromHeartbeat('workflowCalendar');
         */
    }

    ngOnDestroy() {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }

        this.unwatchWorkflow();
        this.unwatchWorkflowCalendar();
    }
}
